import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const resourceHandlerSelector = createSelector(rootSelector, state => state.resourceHandler);
